import { render, staticRenderFns } from "./Edit-Comment.vue?vue&type=template&id=af47d0ce&scoped=true&"
import script from "./Edit-Comment.vue?vue&type=script&lang=js&"
export * from "./Edit-Comment.vue?vue&type=script&lang=js&"
import style0 from "./Edit-Comment.vue?vue&type=style&index=0&id=af47d0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af47d0ce",
  null
  
)

export default component.exports